import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LoaderService, RouterStoreService } from 'thkee-common';

@Component({
  selector: 'app-instructor-sidebar',
  templateUrl: './instructor-sidebar.component.html',
  styleUrls: ['./instructor-sidebar.component.scss'],
  standalone: true,
  imports: [RouterLink, AngularSvgIconModule],
})
export class InstructorSidebarComponent implements OnInit {
  @Input() fullSize: boolean = false;
  activeRoute: string = '/instructor/courses';

  constructor(private routerStoreService: RouterStoreService, private loaderService: LoaderService) {
    this.routerStoreService.getUrl().subscribe((data) => {
      this.activeRoute = data;
    });
  }

  ngOnInit(): void {}

  isActive(route = 'courses') {
    return this.activeRoute.endsWith(route) ? true : false;
  }

  isActiveChild(route = '/instructor/assignments/course-list', slice: number) {
    const parts = this.activeRoute.split('/');
    const firstTwoParts = parts.slice(0, slice).join('/');
    return firstTwoParts.endsWith(route) ? true : false;
  }

  isActiveQueryMenu(route = '/instructor/courses', slice: number) {
    const parts = this.activeRoute.split('?');
    const firstTwoParts = parts.slice(0, slice).join('?');
    return firstTwoParts.endsWith(route) ? true : false;
  }

  hideSidebar() {
    this.loaderService.loaderAction('instructor-course-mobile-toggle', 'success');
  }
}
